module.exports = __webpack_public_path__ + "static/tr-2-8f7428f83a510b6af2b2cdfc03d3de38.png";